import React, { useEffect } from "react";
import "./PartnersSection.css";
import { motion } from "framer-motion";

// image imports — replace with your real files or URLs
import trainingImg from "../assets/Institute/Success-review.JPG"; // main image
import logo1 from "../assets/partner1.avif";
import logo2 from "../assets/partner2.avif";

const PartnersSection = () => {
  // Counter animation
  useEffect(() => {
    const counters = document.querySelectorAll(".stat-num");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            counters.forEach((counter) => {
              const updateCount = () => {
                const target = +counter.getAttribute("data-target");
                const count = +counter.innerText;
                const increment = target / 80;
                if (count < target) {
                  counter.innerText = Math.ceil(count + increment);
                  setTimeout(updateCount, 30);
                } else {
                  counter.innerText = `${target}+`;
                }
              };
              updateCount();
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(document.querySelector(".partners-stats"));
  }, []);

  return (
    <section className="partners-section" id="partners">
      <div className="partners-inner">
        {/* LEFT TEXT */}
        <motion.div
          className="partners-left"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2>
            <span className="muted">How to start the</span>
            <br />
            <span className="blue">NIECCE</span>{" "}
            <span className="red">"Authorised Training Center"</span>
          </h2>

          <p className="partners-lead">
            Enhance your career or business with the NIECCE Teachers Training
            Institute — an exclusive opportunity for qualified individuals and
            organizations to pioneer in early childhood education. Establish an
            Authorized Training Institute of NIECCE and deliver best-in-class
            Nursery, Montessori, and Pre-primary teacher training programs in
            your city.
          </p>

          <div className="partners-ctas">
            <a
              className="btn primary"
              href="https://forms.gle/5rAux1Xs3fzU79M58"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now for New Center
            </a>
            <a className="btn ghost" href="/contact">
              Find Existing Centers
            </a>
          </div>

          <div className="partners-logos">
            <img
              src={logo1}
              alt="NIECCE teacher training logo"
              title="NIECCE teacher training"
            />
            <img
              src={logo2}
              alt="NIECCE education partner logo"
              title="NIECCE education partner"
            />
          </div>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
  className="partners-right"
  initial={{ opacity: 0, y: 60 }}  // start 60px below
  whileInView={{ opacity: 1, y: 0 }} // animate to original position
  transition={{ duration: 0.7 }}
>
          <div className="image-card">
            <img
              src={trainingImg}
              alt="NIECCE authorised teacher training center"
              title="NIECCE authorised teacher training center"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>

      {/* STATS SECTION */}
      <div className="partners-stats">
        <div className="stat">
          <div className="stat-num" data-target="8500">
            0
          </div>
          <p className="stat-label">Teachers Trained</p>
        </div>
        <div className="stat">
          <div className="stat-num" data-target="25">
            0
          </div>
          <p className="stat-label">Authorised Training Centers</p>
        </div>
        <div className="stat">
          <div className="stat-num" data-target="1">
            0
          </div>
          <p className="stat-label">
            Ranked No.1 Pre-Primary Teacher Training
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
